










































































































































import OptionSelect from "../../core/Forms/OptionSelect.vue";
import { EmployeApi } from "../../api/EmployeApi";
import moment from "moment";
import { Employe } from "../../models/Employe";
import AcquisitionConges = Employe.AcquisitionConges;
import InputField from "../../core/Forms/InputField.vue";
import NumeralInput from "../../core/Forms/NumeraInput.vue";

export default {
    name: "CongesTableHeader",
    components: { NumeralInput, InputField, OptionSelect },
    props: {
        employeId: Number,
        filters: Object,
    },
    data() {
        return {
            acquisitionConges: null,
            selectedPeriod: null,
            employe: null,
            periodes: [],
            absences: [],
            fullPeriode: false,
            initialYear: moment().year(),
            initialSolde: 0,
            EmployeApi: new EmployeApi(),
        };
    },
    created() {
        let self = this;
        let promises = [];
        promises.push(self.getEmploye());
        promises.push(self.getAbsences());
        Promise.all(promises).then(function () {
            self.populatePeriodes();
        });
    },
    computed: {
        currentPeriod: function (): boolean {
            let now = moment().format("YYYY-MM-DD");
            return (
                this.acquisitionConges &&
                this.acquisitionConges.start_date <= now &&
                this.acquisitionConges.end_date >= now
            );
        },
    },
    methods: {
        getEmploye() {
            let self = this;
            return self.EmployeApi.get(this.employeId).then(function (res) {
                self.employe = res;
            });
        },
        getAbsences() {
            let self = this;
            return self.EmployeApi.getAbsences(self.employeId).then(function (
                res
            ) {
                self.absences = res;
            });
        },
        populatePeriodes: function () {
            let self = this;
            let dateDebut = null;
            if (self.employe.date_entree_entreprise) {
                dateDebut = moment(self.employe.date_entree_entreprise);
            } else {
                let firstAbsence = _.chain(self.absences)
                    .sortBy("date_debut")
                    .first()
                    .value();
                dateDebut = moment(firstAbsence.date_debut);
            }
            let anneeDebut = dateDebut.subtract(1, "year").year();
            let anneeFin = moment().add(2, "year").year();

            for (let i = anneeDebut; i < anneeFin; i++) {
                self.periodes.push({
                    id: i + "-" + (i + 1),
                    name: i + "/" + (i + 1),
                });
            }
            self.selectCurrentPeriod();
        },
        selectCurrentPeriod: function () {
            let self = this;
            let currentYear = moment().year();
            let currentPeriodStart = currentYear + "-06-01";
            let currentPeriodId = null;
            if (moment().format("YYYY-MM-DD") >= currentPeriodStart) {
                currentPeriodId = currentYear + "-" + (currentYear + 1);
            } else {
                currentPeriodId = currentYear - 1 + "-" + currentYear;
            }
            if (
                currentPeriodId &&
                _.find(self.periodes, { id: currentPeriodId })
            ) {
                self.selectedPeriod = currentPeriodId;
            } else {
                self.selectedPeriod = _.last(self.periodes).id;
            }
        },
        setInitialValue() {
            let self = this;
            return self.EmployeApi.setAcquisitionCongesInitialValue(
                self.employeId,
                self.initialYear,
                self.initialSolde
            ).then(function (res) {
                self.getEmploye();
                self.updateStats();
            });
        },
        toggleFullPeriode: function () {
            return (this.fullPeriode = !this.fullPeriode);
        },
        humanReadableDate: function (date: string): string {
            let mDate = moment(date);
            return mDate.format("DD/MM/YY");
        },
        updateStats: function () {
            let self = this;
            let startYear = _.chain(this.selectedPeriod)
                .split("-")
                .first()
                .value();
            if (!startYear) {
                return;
            }
            this.EmployeApi.getAcquisitionConges(this.employeId, startYear, {
                full_periode: this.fullPeriode,
            }).then(function (res: AcquisitionConges) {
                self.acquisitionConges = res;
                self.filters.startDate = res.start_date;
                self.filters.endDate = res.end_date;
            });
        },
    },
    watch: {
        selectedPeriod: {
            immediate: true,
            handler: function () {
                this.updateStats();
            },
        },
        fullPeriode: {
            immediate: true,
            handler: function () {
                this.updateStats();
            },
        },
    },
};
